import { Padding } from '@mui/icons-material';
import React, { useState } from 'react';
// import "./style/AddfundStyle.css";

const AddFundsPage: React.FC = () => {
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null);
  const [customAmount, setCustomAmount] = useState('');
  const [couponCode, setCouponCode] = useState('');

  const amounts = [300, 500, 1000, 2500, 10000];

  const handleAmountClick = (amount: number) => {
    setSelectedAmount(amount);
    setCustomAmount('');
  };

  const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAmount(null);
    setCustomAmount(e.target.value);
  };

  const handleActivateCoupon = () => {
    alert(`Coupon Activated: ${couponCode}`);
  };

  const handlePaymentOptionClick = (method: string) => {
    alert(`Payment Method Selected: ${method}`);
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)',
    padding: '20px',
    borderRadius: '0px',
    height: 'auto',
  };

  const titleStyle = {
    fontSize: '18px',
    marginBottom: '20px',
    textAlign: 'left' as const,
    fontWeight:'400',
    marginRight:'40px'
  };

  const buttonStyle1 = {
    padding: '10px 20px',
    border: '1px solid #1173B7',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop:'10px',
    fontSize: '10px',
    backgroundColor: 'white',
    marginRight: '10px',
    
    textAlign: 'center' as const,
  };

  const buttonStyle = {
    padding: '5px',
    border: '1px solid #1173B7',
    // borderRadius: '4px',
    
    cursor: 'pointer',
    fontSize: '10px',
    backgroundColor: 'white',
    marginRight: '0px 10px',
    
    textAlign: 'center' as const,
  };

  const selectedButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#1173B7',
    color: 'white',
    padding:'10px  20px',
    marginTop:'10px',
        borderRadius: '4px',

  };

  const inputStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '12px',
    marginBottom: '10px',
  };

  const paymentOptionStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '10px',
    marginBottom: '10px',
    cursor: 'pointer',
    backgroundColor: '#F5F5F5',
  };

  const paymentOptionTextStyle = {
    fontSize: '12px',
  };

  const paymentIconsStyle = {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  };

  const arrowStyle = {
    fontSize: '16px',
    fontWeight: 'bold' as const,
    color: '#1173B7',
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '80%', textAlign: 'left', margin: '0 20px' }}>

        <div style={{ display: 'flex' }}>
          <h2 style={titleStyle}>Add Funds:</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '20px' }}>
            {amounts.map((amount) => (
              <button
                key={amount}
                style={selectedAmount === amount ? selectedButtonStyle : buttonStyle1}
                onClick={() => handleAmountClick(amount)}
              >
                {amount === 1000 && <span style={{ color: 'red', marginRight: '5px' }}>Popular</span>}<br></br>
                ${amount}
              </button>
            ))}
            <div style={{ display: 'flex', alignItems: 'center'}}>
              <input
                type="text"
                placeholder="Custom Amount ($100 minimum)"
                value={customAmount}
                onChange={handleCustomAmountChange}
                style={{ ...inputStyle, width: '120px', marginLeft: '10px', fontSize:'9px', marginBottom:'-10px' }}
              />
            </div>
          </div>
        </div>





        <div style={{ marginBottom: '20px', textAlign:'center', marginRight:'50px' }}>
          <input
            type="text"
            placeholder="Have a Coupon Code?"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            style={{ ...inputStyle, width: '15%', marginRight:'30px', padding:'5px' }}
          />
          <button onClick={handleActivateCoupon} style={selectedButtonStyle}>
            Activate Coupon
          </button>
        </div>
        <h3 style={titleStyle}>Payment Sources:</h3>
        {[
          {
            name: 'Credit Cards',
            fee: 'No Fees',
            status: 'IMMEDIATE FUNDING',
            icons: ['Visa', 'MasterCard', 'AmEx', 'Discover', 'Diners Club'],
          },
          {
            name: 'PayPal',
            fee: 'No Fees',
            status: 'MANUAL APPROVAL',
            icons: ['PayPal'],
          },
          {
            name: 'Capitalist',
            fee: 'No Fees',
            status: 'IMMEDIATE FUNDING',
            icons: ['Capitalist'],
          },
          {
            name: 'Cryptomus',
            fee: 'No Fees',
            status: 'IMMEDIATE FUNDING',
            icons: ['BTC', 'ETH', 'TRX'],
          },
          {
            name: 'Paxum',
            fee: 'No Fees',
            status: 'IMMEDIATE FUNDING',
            icons: ['Paxum'],
          },
          {
            name: 'WebMoney',
            fee: '(15% Fee)',
            status: 'IMMEDIATE FUNDING',
            icons: ['WebMoney'],
          },
        ].map((payment) => (
          <div
            key={payment.name}
            style={paymentOptionStyle}
            onClick={() => handlePaymentOptionClick(payment.name)}
          >
            <div>
              <p style={paymentOptionTextStyle}>
                {payment.name} <span style={{ fontWeight: 'bold' }}>{payment.fee}</span>
              </p>
              <p style={{ fontSize: '10px', color: 'gray' }}>{payment.status}</p>
            </div>
            <div style={paymentIconsStyle}>
              {payment.icons.map((icon, idx) => (
                <span key={idx} style={{ fontSize: '14px', fontWeight: 'bold' }}>
                  {icon}
                </span>
              ))}
              <span style={arrowStyle}>&gt;</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddFundsPage;
